<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "AdminBaseComponent"
}
</script>

<style scoped>

</style>
